import { render } from "./TariffRoleElement.vue?vue&type=template&id=02f2fe2c"
import script from "./TariffRoleElement.vue?vue&type=script&lang=js"
export * from "./TariffRoleElement.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/standart-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__